import React from 'react';
import { Button, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, Separator, } from '@cargomatic/ui';
import { ChevronDown } from 'lucide-react';
import { Badge } from 'components/design-system/molecules/badge-fix';
/**
 * Multi-select filter dropdown with badge display for selected values.
 */
export function FilterDropdown({ title, options, selected, onCheckedChange, onClear, onSelectAll, }) {
    const selectedLabels = options
        .filter((opt) => selected.includes(opt.value))
        .map((opt) => opt.label);
    const count = selectedLabels.length;
    const allSelected = count === options.length && options.length > 0;
    const handleClear = () => {
        if (onClear) {
            onClear();
        }
        else {
            const toRemove = [...selected];
            toRemove.forEach((value) => onCheckedChange(value, false));
        }
    };
    const handleSelectAll = () => {
        if (onSelectAll) {
            onSelectAll();
        }
        else {
            const toAdd = options.filter((opt) => !selected.includes(opt.value));
            toAdd.forEach((opt) => onCheckedChange(opt.value, true));
        }
    };
    return (React.createElement(DropdownMenu, null,
        React.createElement(DropdownMenuTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-start border-dashed h-8 font-normal" },
                React.createElement("span", { className: "truncate" }, title),
                count > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { orientation: "vertical", className: "mx-2 h-4" }),
                    count > 2 ? (React.createElement(Badge, { className: "rounded-sm px-1 font-normal" },
                        count,
                        " selected")) : (React.createElement("div", { className: "flex gap-1" }, selected.map((value) => {
                        const opt = options.find((o) => o.value === value);
                        return (React.createElement(Badge, { key: value, className: "rounded-sm px-1 font-normal" }, (opt === null || opt === void 0 ? void 0 : opt.label) || value));
                    }))))),
                count === 0 && (React.createElement(ChevronDown, { className: "h-3 w-3 ml-auto opacity-50" })))),
        React.createElement(DropdownMenuContent, { style: { minWidth: 'var(--radix-dropdown-menu-trigger-width)' } },
            React.createElement("div", { className: "max-h-60 overflow-y-auto" }, options.map((opt) => (React.createElement(DropdownMenuCheckboxItem, { key: opt.value, checked: selected.includes(opt.value), onCheckedChange: (checked) => onCheckedChange(opt.value, checked) }, opt.label)))),
            React.createElement(DropdownMenuSeparator, null),
            React.createElement(DropdownMenuItem, { onClick: handleSelectAll, disabled: allSelected, className: "pl-8" }, "Select All"),
            React.createElement(DropdownMenuItem, { onClick: handleClear, disabled: count === 0, className: "pl-8" }, "Clear"))));
}
